import { Button, Tooltip } from '@cian/ui-kit';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

interface IHeartFavouriteButtonProps {
  isFavorite: boolean;
  onClick(): void;
}

export const HeartFavouriteButton: React.FC<IHeartFavouriteButtonProps> = ({ isFavorite, onClick }) => {
  return (
    <Tooltip placement="bottom" title={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}>
      <Button
        size="M"
        theme="stroke_primary"
        onClick={onClick}
        beforeIcon={
          isFavorite ? (
            <IconToggleHeartOn16 color="icon-negative-default" />
          ) : (
            <IconToggleHeartOff16 color="icon-main-default" />
          )
        }
        data-testid="HeartFavouriteButton"
        data-mark={isFavorite ? 'Favorite' : 'NotFavorite'}
      />
    </Tooltip>
  );
};
